<template lang='pug'>
.dropdown(@blur='open = false')
    label.dropdown-label(v-if='label') {{ label }}
    .selected(v-if='isSelect', :class='{ open: open }', @click='open = !open')
        span(v-if='selected') {{ selected[props.label] }}
    .dropdown-icon(v-else)
        chip-component.icon-dropdown(
            border-color='transparet',
            background-color='transparent',
            color='black',
            icon='mdi-dots-vertical',
            @click.native='open = !open'
        )
    dropdown-box-component(
        v-if='open',
        :list='list',
        :props='propsView',
        :position='position',
        :has-scroll='hasScroll',
        @click='click',
        @close='open = false'
    )
</template>

<script>
import DropdownBoxComponent from './DropdownBoxComponent.vue';

export default {
    components: {
        DropdownBoxComponent,
    },
    props: {
        list: {
            type: Array,
            required: true,
        },
        isSelect: {
            type: Boolean,
            default: true,
        },
        position: {
            type: String,
            default: 'right',
            validator: function (value) {
                return ['left', 'right', 'bottom', 'top'].includes(value);
            },
        },
        hasScroll: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            default: null,
        },
        props: {
            type: Object,
            default: () => ({
                id: 'id',
                icon: 'icon',
                label: 'label',
            }),
        },
    },
    data() {
        return {
            open: false,
            selected: null,
            propsView: Object.assign(
                {
                    id: 'id',
                    icon: 'icon',
                    label: 'label',
                },
                this.props
            ),
        };
    },
    methods: {
        click(option) {
            this.selected = option;
            this.open = false;
            this.$emit('input', option);
        },
    },
};
</script>

<style scoped>
.dropdown {
    position: relative;
    max-width: 400px;
    max-height: 300px;
    text-align: left;
    outline: none;
    line-height: 29px;
}

.icon-dropdown {
    cursor: pointer;
}

.dropdown .selected {
    /* background-color: var(--primary-light-green); */
    border-radius: 6px;
    border: 2px solid var(--primary-light-green) !important;
    color: var(--primary-green);
    padding-left: 1em;
    cursor: pointer;
    user-select: none;
    height: 30px;
}

.dropdown .selected:focus-visible {
    border: 2px solid var(--primary-green) !important;
    border-radius: 5px;
    outline: none;
}

.dropdown .selected.open {
    border: 1px solid var(--primary-green);
    border-radius: 6px;
}
</style>
